import ApiError from '@a24/av-sdk/api-error'

/**
 * Validate if the error is an instance of ApiError or has the structure of an API error.
 * This is useful for type narrowing in TypeScript.
 */
export const isApiError = (error: any): error is ApiError => {
  return (
    error instanceof ApiError ||
    (error &&
      typeof error === 'object' &&
      'exception' in error &&
      'message' in error)
  )
}
